import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
    interface TypographyVariants {
        bike_50: React.CSSProperties;
        moped_75: React.CSSProperties;
        motorcycle_90: React.CSSProperties;
        car_100: React.CSSProperties;
        hatchback_125: React.CSSProperties;
        suv_150: React.CSSProperties;
        truck_175: React.CSSProperties;
        van_225: React.CSSProperties;
        bus_350: React.CSSProperties;
        semi_450: React.CSSProperties;
    }

    // allow configuration using `createTheme`
    interface TypographyVariantsOptions {
        bike_50?: React.CSSProperties;
        moped_75?: React.CSSProperties;
        motorcycle_90?: React.CSSProperties;
        car_100?: React.CSSProperties;
        hatchback_125?: React.CSSProperties;
        suv_150?: React.CSSProperties;
        truck_175?: React.CSSProperties;
        van_225?: React.CSSProperties;
        bus_350?: React.CSSProperties;
        semi_450?: React.CSSProperties;
    }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
        bike_50: true;
        moped_75: true;
        motorcycle_90: true;
        car_100: true;
        hatchback_125: true;
        suv_150: true;
        truck_175: true;
        van_225: true;
        bus_350: true;
        semi_450: true;
    }
}

const theme = createTheme({
    palette: {
        primary: {
            main: "#3B7A80",
        },
        secondary: {
            main: "#3F5261",
        },
        background: {
            default: "#fff",
        },
        error: {
            main: "#E0284A",
        },
    },
    spacing: [4, 8, 12, 16, 24, 32, 40, 48, 56, 64, 72, 80, 96],
    typography: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        bike_50: {
            fontSize: "0.625rem",
            lineHeight: "1rem",
            letterSpacing: "0.05rem",
            margin: "none",
        },
        moped_75: {
            fontSize: "0.75rem",
            lineHeight: "1rem",
            letterSpacing: "0.045rem",
            margin: "none",
        },
        motorcycle_90: {
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            letterSpacing: "0.01rem",
            margin: "none",
        },
        car_100: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            letterSpacing: "0.01rem",
            margin: "none",
        },
        hatchback_125: {
            fontSize: "1.125rem",
            lineHeight: "1.5rem",
            letterSpacing: "0.01rem",
            margin: "none",
        },
        suv_150: {
            fontSize: "1.5rem",
            lineHeight: "2rem",
            letterSpacing: "0.0075rem",
            margin: "none",
        },
        truck_175: {
            fontSize: "1.75rem",
            lineHeight: "2.5rem",
            margin: "none",
        },
        van_225: {
            fontSize: "2.25rem",
            lineHeight: "3rem",
            margin: "none",
        },
        bus_350: {
            fontSize: "3.5rem",
            lineHeight: "4.5rem",
            margin: "none",
        },
        semi_450: {
            fontSize: "4.5rem",
            lineHeight: "7rem",
            margin: "none",
        },
        button: {
            textTransform: "none",
        },
    },
});
export default theme;
